import { useEffect, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import api from "../../../../utils/api";
import socket from "../../../../context/socket";

const QRUploadModal = ({
    show,
    setShowQRUpoaderModal,
    client_id,
    getAllExternalFoliosAdvisor,
    roomId,
    onExternalPortfolioImported,
}) => {
    const [status, setStatus] = useState("idle");
    const [clientRefNo, setClientRefNo] = useState("");
    const [otpRef, setOtpRef] = useState("");
    const [reqId, setReqId] = useState("");
    const [verifiedPan, setVerifiedPan] = useState(null);

    const onHide = () => {
        if (status === "complete") {   
            getAllExternalFoliosAdvisor?.();
            onExternalPortfolioImported?.(verifiedPan);
        }
        setShowQRUpoaderModal(false);
        setStatus("idle");
        setVerifiedPan(null);
    }

    const handleClose = () => {
        socket.emit("join", { room: roomId });
        socket.emit("message_to", {
            room: roomId,
            data: {
                location: "qr_verify",
                isClosed: true,
                status: status
            },
        });
        onHide();
    }

    // 🔹 Fetch clientRefNo
    const fetchMfCenteralByClient = async () => {
        try {
            const response = await api.post(
                `advisor/getMfCentralByClientId`,
                { client_id }
            );
console.log("response",response)
            if (response?.data) {
                setClientRefNo(response.data.data.clientRefNo);
                setOtpRef(response.data.data.clientRefNo);
                setReqId(response.data.data.clientRefNo);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if (client_id && show) {
            // fetchMfCenteralByClient();
        }
    }, [client_id, show]);

    useEffect(() => {
        if (!roomId) return;
        socket.emit("join", { room: roomId });
        const handleMessage = (msg) => {
            if (msg.data.location === "qr_verify_client") {
                if (msg?.data?.isVerified) {
                    setStatus("complete");
                    if (msg?.data?.pan) {
                        setVerifiedPan(msg.data.pan);
                    }
                }
                if (msg?.data?.isClosed) {
                    onHide();
                    if (msg?.data?.status === "complete") {
                        getAllExternalFoliosAdvisor?.();
                        onExternalPortfolioImported?.(msg?.data?.pan || verifiedPan);
                    }
                }
            }

        };

        socket.on("message_to", handleMessage);

        return () => {
            socket.off("message_to", handleMessage);
        };
    }, [roomId]);

  

    const handleFileChange = async (e) => {
        if (!e.target.files || e.target.files.length === 0) return;

        const file = e.target.files[0];

        console.log("Selected File:", file);

        const reader = new FileReader();

        reader.onloadend = async () => {
            try {
                const base64String = reader.result;

                console.log("Full Base64:", base64String);
          

                // remove data:image/png;base64,
                const rawBase64 = base64String.split(",")[1];

                console.log("rawBase64Length",rawBase64.length);
                console.log("rawBase64", rawBase64.trim().length);


                setStatus("loading");

                const payload = {
                    client_id,
                    qrCode: rawBase64,
                };

                console.log("Payload:", payload);

                const response = await api.post(
                    `advisor/verifyMfCentralQrCode`,
                    payload
                );

                console.log("API Response:", response);

                // Axios response
                if (response?.data?.success === false) {
                    throw new Error(response?.data?.message || "QR validation failed");
                }

                if (response?.data?.pan) {
                    setVerifiedPan(response.data.pan);
                }
                setStatus("complete");
                socket.emit("join", { room: roomId });
                socket.emit("message_to", {
                    room: roomId,
                    data: {
                        location: "qr_verify",
                        isVerified: true,
                        pan: response?.data?.pan,
                    },
                });

            } catch (error) {
                console.log("Upload Error:", error);

                alert(
                    error?.response?.data?.message ||
                    error.message ||
                    "Something went wrong"
                );

                setStatus("idle");
                e.target.value = "";
            }
        };

        reader.readAsDataURL(file);
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Upload QR Code</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">
                <p>Upload the QR code you received from mfCentral</p>

                <input
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={handleFileChange}
                    disabled={status !== "idle"}
                />

                {status === "loading" && (
                    <div className="mt-3">
                        <Spinner animation="border" size="sm" />
                        <p>Validating QR Code...</p>
                    </div>
                )}

                {status === "complete" && (
                    <p className="text-success mt-3">
                        ✅ Validation Successful!
                    </p>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant={status === "complete" ? "success" : "secondary"}
                    onClick={handleClose}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default QRUploadModal;